import axios from "axios";
import { startWsJob } from "../ws/AsyncJobService";
import { PDA_PREFIX } from "../../global/constants";

/**
 * Starts a Reset Capacity job via the shared AsyncJobService.
 * Subscribes to /topic/capacity-reset/{username}, fires the POST, and
 * invokes callbacks as WS frames arrive.
 */
export function startResetCapacityWebSocket(callbacks = {}) {
  const {
    onJobStarted = () => {},
    onQueued = () => {},
    onItemStarted = () => {},
    onItemCompleted = () => {},
    onItemFailed = () => {},
    onFinalizing = () => {},
    onAllCompleted = () => {},
    onAllFailed = () => {},
    onRequestError = () => {},
  } = callbacks;

  const username = localStorage.getItem("username");
  const fallbackTopic = `/topic/capacity-reset/${username}`;

  return startWsJob(
    {
      postFn: () => axios.post(`${PDA_PREFIX}/usages/all/reset-capacity-ws`),
      fallbackTopic,
      kind: "RESET_CAPACITY",
    },
    {
      onJobStarted,
      onQueued,
      onItemStarted,
      onItemCompleted,
      onItemFailed,
      onFinalizing,
      onAllCompleted,
      onAllFailed,
      onRequestError,
    }
  );
}
